import { defineAsyncComponent } from 'vue';

import { toPlugin, type ComponentType, type Plugin } from '@bv/helpers/components';

export {
  BvTextInput,
  BvFileInput,
  BvTextarea,
  BvSearchInput,
  BvColorInput,
  BvTelInput,
  BvSelectInput,
  BvDateInput,
  BvCalendar,
  BvSwitch,
  BvTagInput,
  BvAttachInput,
  BvTimeInput,
  BvOtp,
  BvRadio,
  BvBusinessHours,
} from './inputs';

export { default as BvBtn } from './button/BvBtn.vue';
export type { BvBtnVariant } from './button/variant';

export { default as BvTestButton } from './BvTestButton/BvTestButton.vue';

export const formArray: ComponentType[] = [
  {
    name: 'BvBtn',
    component: defineAsyncComponent(() => import('@bv/components/form/button/BvBtn.vue')),
  },
  {
    name: 'BvOtp',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/otp/BvOtp.vue')),
  },
  {
    name: 'BvTextInput',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/text/BvTextInput.vue')),
  },
  {
    name: 'BvPasswordInput',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/password/BvPasswordInput.vue')),
  },
  {
    name: 'BvTextarea',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/textarea/BvTextarea.vue')),
  },
  {
    name: 'BvSearchInput',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/search/BvSearchInput.vue')),
  },
  {
    name: 'BvSelectInput',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/select/BvSelectInput.vue')),
  },
  {
    name: 'BvSelectList',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/select/BvSelectList.vue')),
  },
  {
    name: 'BvSwitch',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/switch/BvSwitch.vue')),
  },
  {
    name: 'BvColorInput',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/color/BvColorInput.vue')),
  },
  {
    name: 'BvTelInput',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/tel/BvTelInput.vue')),
  },
  {
    name: 'BvTestButton',
    component: defineAsyncComponent(() => import('@bv/components/form/BvTestButton/BvTestButton.vue')),
  },
  {
    name: 'BvDateInput',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/date/BvDateInput.vue')),
  },
  {
    name: 'BvCalendar',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/date/BvCalendar.vue')),
  },
  {
    name: 'BvTagInput',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/tag/BvTagInput.vue')),
  },
  {
    name: 'BvFilter',
    component: defineAsyncComponent(() => import('@bv/components/form/filter/BvFilter.vue')),
  },
  {
    name: 'BvFileInput',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/file/BvFileInput.vue')),
  },
  {
    name: 'BvCopyBtn',
    component: defineAsyncComponent(() => import('@bv/components/form/copy-btn/BvCopyBtn.vue')),
  },
  {
    name: 'BvAttachInput',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/attach/BvAttachInput.vue')),
  },
  {
    name: 'BvTimeInput',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/time/BvTimeInput.vue')),
  },
  {
    name: 'BvCheckbox',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/checkbox/BvCheckbox.vue')),
  },
  {
    name: 'BvRadio',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/radio/BvRadio.vue')),
  },
  {
    name: 'BvBusinessHours',
    component: defineAsyncComponent(() => import('@bv/components/form/inputs/business-hours/BvBusinessHours.vue')),
  },
];

export const form: Plugin<[]> = toPlugin(formArray);
